import React, { useEffect, useState } from 'react'
import { Button, Col, Dropdown, Form, Modal, Row } from 'react-bootstrap'
import search from "../../assets/search.svg";
import '../auth/element.css';
import { callApi } from '../utills/api';
import { showAlert, showError, showSuccess } from '../utills/sweetAlert';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { faFile, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPaginate from 'react-paginate';
import TopNavBar from '../Layout/TopNavBar';
import upload from "../../assets/upload.svg";

const { RangePicker } = DatePicker;

interface Vendor {
    id: number;
    site_name: string;
    location: string;
    create_date: string;
}

const Testimonials: React.FC = () => {
    const [siteModal, setSiteShow] = useState(false);
    const [siteDetails, setSiteDetails] = useState<any[]>([]);
    const siteShow = () => setSiteShow(true);
    const siteClose = () => {
        setState((prevState) => ({
            ...prevState,
            name: "",
            description: "",
            starCount: "",
            role: "",
            id: "",
            image: ""
        }));

        setSiteShow(false);
        setShowImage(false);
        setErrorMessage("");
        setSuccessMessage("");

    }

    const [state, setState] = useState({
        CatId: "",
        MasterId: "",
        SubcategoryName: "",
        MasterOptionselect: [],
        name: "",
        description: "",
        starCount: "",
        role: "",
        image: "",
        id: "",
    });

    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [attachments, setAttachments]: any = useState([
        {
            deleteStatus: false,
            imageType: "",
            imageData: "",
            updateStatus: false,
        },
    ]);

    const [showImage, setShowImage] = useState(false);
    const handleImageClose = () => {
        setShowImage(false);
    };
    const [imageError, setImageError] = useState("");

    const siteOnchange = (event: any) => {
        const { name, value } = event.target;
        const sanitizedValue = value.replace(/ {2,}/g, ' ');
        setState((prevState) => ({
            ...prevState,
            [name]: sanitizedValue ,
        }));
    }

    const handleSubmit = (event: any) => {
        const form = event.target.form;
        if (form.checkValidity() === false) {
            console.log("Form validation failed.");
            return;
        }
        event.preventDefault();
console.log("attachments-->",attachments);

        if (attachments[0].imageData == "") {
            console.log("not coming");
            event.preventDefault();
            setImageError("Upload Image Required.");

        } else {

            const trimmedName = state.name.trim();
            const trimmedDesc = state.description.trim();
            if (trimmedName && trimmedDesc) {
                let request = {
                    name: trimmedName,
                    description: trimmedDesc,
                    starCount: state.starCount,
                    role: state.role,
                    attachment: attachments

                }
                console.log("request-->", request);

                callApi("POST", "testimonialInsert.php", request)
                    .then((res) => res.data)
                    .then((response) => {
                        if (response) {
                            showSuccess("Success!", "Testmonials Created Successfully!");
                            setState((prevState) => ({
                                ...prevState,
                                name: "",
                                description: "",
                                starCount: "",
                                role: "",
                                id: ""
                            }));
                            setErrorMessage("");
                            setSuccessMessage("");
                            setSiteShow(false);
                            tableCategoryShow();

                            setAttachments((prevAttachments: any) => [
                                ...prevAttachments.slice(0, prevAttachments.length - 1), // Remove the last element
                                {
                                    ...prevAttachments[prevAttachments.length - 1],
                                    imageData: "", // Set the base64 data
                                    imageType: "",
                                    updateStatus: "",
                                },
                            ]);
                        }
                    })
                    .catch((err: any) => {
                        console.error(
                            "API call error:",
                            err.response ? err.response.data.error : err.message
                        );
                        showError(
                            "Failed",
                            err.response ? err.response.data.error : err.message
                        );
                    });
            } else {
                showError(
                    "Failed", "Empty Space Not Allowed");
            }

        }

    }

    useEffect(() => {
        tableCategoryShow();
    }, []);


    const tableCategoryShow = () => {
        callApi("GET", "testimonialSelect.php", "")
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    console.log("response--->", response.data);
                    setSiteDetails(response.data);
                    console.log("siteDetails--->", siteDetails);
                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }


    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearch = (term: string) => {
        setSearchTerm(term);
    };

    const filteredData = siteDetails.filter((item: any) =>
        Object.values(item).some((value) =>
            (value as string).toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    // Calculate pagination for filtered data
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const offset = currentPage * itemsPerPage;
    const currentData = filteredData.slice(offset, offset + itemsPerPage);
    const handlePageClick = (event: { selected: number }) => {
        setCurrentPage(event.selected);
    };

    // Calculate the display range for the items
    const startItem = offset + 1;
    const endItem = Math.min(offset + itemsPerPage, filteredData.length);


    const handleEdit = (id: any) => {
        let req = {
            id: id,
        };
        callApi("POST", "testimonialSingleSelect.php", req)
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    console.log("response-->", response.data[0].name);

                    setState((prevState) => ({
                        ...prevState,
                        id: response.data[0].id,
                        name: response.data[0].name,
                        role: response.data[0].role,
                        description: response.data[0].description,
                        starCount: response.data[0].starCount,
                        image: response.data[0].image,

                    }));
                    setSiteShow(true);
                    setShowImage(true);
                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }

    const handleUpdate = (event: any) => {
        const form = event.target.form;
        event.preventDefault();
        const trimmedName = state.name.trim();
        const trimmedDesc = state.description.trim();

        if (trimmedName && trimmedDesc) {
            let request = {
                id: state.id,
                name: trimmedName,
                description: trimmedDesc,
                starCount: state.starCount,
                role: state.role,
                attachment: attachments

            }

            callApi("POST", "testimonialUpdate.php", request)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        showSuccess("Success!", "Testmonials Updated Successfully!");
                        setState((prevState) => ({
                            ...prevState,
                            name: "",
                            description: "",
                            starCount: "",
                            role: "",
                            image: "",
                            id: ""
                        }));

                        setSiteShow(false)
                        tableCategoryShow();
                        setErrorMessage("");
                        setSuccessMessage("");
                    }
                })
                .catch((err: any) => {
                    console.error(
                        "API call error:",
                        err.response ? err.response.data.error : err.message
                    );
                    showError(
                        "Failed",
                        err.response ? err.response.data.error : err.message
                    );
                });
        }
    }

    const handleInactive = async (id: any, status: any) => {

        const action = status === "Active" ? "Inactivate" : "Activate";
        const isComfirm = await showAlert(
            "Please Confirm",
            `Are you sure you want to ${action}?`,
            "Yes",
            "No"
        );

        console.log("id-->", id);
        if (isComfirm) {
            const activeInactiveStatus = status === "Active" ? "Inactive" : "Active";
            let req = {
                categoryId: id,
                status: activeInactiveStatus,
            };
            callApi("POST", "subCategoryStatusChange.php", req)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        tableCategoryShow();

                    }
                })
                .catch((err: any) => {
                    console.error(
                        "API call error:",
                        err.response ? err.response.data.error : err.message
                    );
                    showError(
                        "Failed",
                        err.response ? err.response.data.error : err.message
                    );
                });
        }
    }

    const validateFile = (file: any) => {
        const validTypes = ["image/jpeg", "image/png", "image/svg+xml"];
        if (!validTypes.includes(file.type)) {
            return "Unsupported file format. Please upload JPEG, PNG, or SVG.";
        }
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {

            convertFileToBase64(file);
            setErrorMessage("");
            URL.revokeObjectURL(img.src);
        };
        return null;
    };

    const convertFileToBase64 = (file: File) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            const base64data = reader.result as string; // Ensure it's a string

            const imageType = file.type.split("/")[1]; // This will give 'image'
            console.log("file.type", imageType);
            setImageError("");

            setAttachments((prevAttachments: any) => [
                ...prevAttachments.slice(0, prevAttachments.length - 1), // Remove the last element
                {
                    ...prevAttachments[prevAttachments.length - 1],
                    imageData: base64data, // Set the base64 data
                    imageType: imageType,
                    updateStatus: true,
                },
            ]);
            setImageError("");
            setSuccessMessage("File uploaded successfully!");
        };
        reader.onerror = () => {
            setErrorMessage("Error converting file to Base64.");
        };
    };

    const handleFileChange = (event: any) => {
        const file = event.target.files[0];
        if (file) {
            setSuccessMessage("");
            const error = validateFile(file);
            if (error) {
                setErrorMessage(error);
            }
        }
    };

    const handleDrop = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        const file = event.dataTransfer.files[0];
        if (file) {
            setSuccessMessage("");
            const error = validateFile(file);
            if (error) {
                setErrorMessage(error);
            }
        }
    };

    const handleDragOver = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const deleteApi = async (id: any) => {
        const isComfirm = await showAlert(
            "Please Confirm",
            `Are you sure you want to Delete ?`,
            "Yes",
            "No"
        );
        if (isComfirm) {
            let req = {
                id: id,
            };
            callApi("POST", "testimonialDelete.php", req)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        showSuccess("Success!", "Testimonials Deleted Successfully!");

                        tableCategoryShow();
                    }
                })
                .catch((err: any) => {
                    console.error(
                        "API call error:",
                        err.response ? err.response.data.error : err.message
                    );
                    showError(
                        "Failed",
                        err.response ? err.response.data.error : err.message
                    );
                });
        }
    }


    return (
        <>
            <div>
                <div className="mobile_nav_bar">
                    <TopNavBar />
                </div>
                <div className="">
                    <Row className='webview'>
                        <div className="category-header">
                            <Col lg="8" md="8">
                                <h3 className="category-title">
                                    Testimonials
                                </h3>
                            </Col>
                            <Col lg="4" md="4" className="headbtn">
                                <button className="cashinbtn"
                                    onClick={siteShow}>
                                    Add Testimonials
                                </button>
                                <div className="search-bar">
                                    <img
                                        src={search}
                                        alt="search-icon"
                                        style={{ width: "22px" }}
                                    />
                                    <input type="text" placeholder="Search..."
                                        onChange={(e) => handleSearch(e.target.value)} />
                                </div>
                            </Col>
                        </div>
                    </Row>

                </div>

                <div className="element-container">

                    {filteredData.length > 0 ? (
                        <div className="table-container">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th> Name</th>
                                        <th>Image</th>
                                        <th>Role</th>
                                        <th>Star Count</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>
                                            {offset + index + 1}
                                            </td>
                                            <td className='boldtd'>{item.name}</td>
                                            <td>
                                                <img
                                                    src={item.image}
                                                    alt="Profile picture"
                                                    style={{ width: "70px", height: "70px" }}
                                                />
                                            </td>
                                            <td>
                                                <span >
                                                    {item.role}
                                                </span>
                                            </td>
                                            <td>
                                                <span >
                                                    {item.starCount}
                                                </span>
                                            </td>


                                            <td>
                                                <div className='webview'>
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle
                                                            variant="link"
                                                            id="dropdown-basic"
                                                            style={{ border: "none", background: "transparent" }}
                                                        ></Dropdown.Toggle>
                                                        <Dropdown.Menu
                                                            id="webdropdown">
                                                            <Dropdown.Item
                                                                onClick={() => handleEdit(item.id)}
                                                            >
                                                                Edit
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => deleteApi(item.id)}
                                                            >
                                                                Delete
                                                            </Dropdown.Item>

                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                                <div className='mblview'>
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle
                                                            variant="link"
                                                            id="dropdown-basic"
                                                            style={{ border: "none", background: "transparent" }}
                                                        ></Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => handleEdit(item.id)}
                                                            >
                                                                Edit
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                            // onClick={() => handleDelete(item.id)}
                                                            >
                                                                Active
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="pagination-container">
                                <div className="pagination-info">
                                    {`${startItem} - ${endItem} of ${filteredData.length}`}
                                </div>
                                <ReactPaginate
                                    previousLabel={'<'}
                                    nextLabel={'>'}
                                    breakLabel={'...'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    activeClassName={'active-page'}
                                    pageClassName={'page-item'}
                                    previousClassName={'prev-next'}
                                    nextClassName={'prev-next'}
                                />
                            </div>
                        </div>
                    ) : (
                        <p className='nodata'>Data Not Found</p>
                    )}
                </div>
            </div>

            <Modal show={siteModal} onHide={siteClose}>
                <Modal.Header closeButton>
                    <h4 className='category-title '>Testimonials Form</h4>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="loginform">

                            <div className="labeldiv">
                                <label className="label"> Name*</label>
                                <input
                                    type="text"
                                    className="form-control bg"
                                    placeholder="Enter Name"
                                    name="name"
                                    minLength={2}
                                    onChange={siteOnchange}
                                    value={state.name}
                                    pattern="^[A-Za-z0-9@#$_%&-]+( [A-Za-z0-9@#$_%&-]+)*$"
                                    maxLength={50}
                                    required />
                            </div>
                            <div className="labeldiv">
                                <label className="label">Description*</label>
                                <input
                                    type="text"
                                    className="form-control bg"
                                    placeholder="Enter Description"
                                    name="description"
                                    minLength={2}
                                    onChange={siteOnchange}
                                    value={state.description}
                                    pattern="^[A-Za-z0-9@#$_%&-]+( [A-Za-z0-9@#$_%&-]+)*$"
                                    maxLength={300}
                                    required />
                            </div>
                            <div className="labeldiv">
                                <label className="label">Role *</label>
                                <Form.Select
                                    aria-label="Default select example"
                                    name="role"
                                    required
                                    onChange={siteOnchange}
                                    value={state.role}
                                    style={{ background: "#dce6ef !important" }}
                                    className='bg'
                                >
                                    <option value="">Select Role</option>
                                    <option value="Teacher">Teacher</option>
                                    <option value="Parent">Parent</option>
                                </Form.Select>
                            </div>
                            <div className="labeldiv">
                                <label className="label">Star Count*</label>
                                {/* <Form.Select
                                    aria-label="Default select example"
                                    name="starCount"
                                    required
                                    onChange={siteOnchange}
                                    value={state.starCount}
                                    style={{ background: "#dce6ef !important" }}
                                    className='bg'

                                >
                                    <option value="">Select Star</option>
                                    <option value="1">One Star</option>
                                    <option value="2">Two Star</option>
                                    <option value="3">Three Star</option>
                                    <option value="4">Four Star</option>
                                    <option value="5">Five Star</option>
                                </Form.Select> */}
                                <input
                                    type="text"
                                    className="form-control bg"
                                    placeholder="Enter Count"
                                    minLength={1}
                                    name="starCount"
                                    required
                                    onChange={siteOnchange}
                                    value={state.starCount}
                                    pattern="^([1-4](\.[0-9])?|5)$"
                                    maxLength={3}
                                />
                            </div>

                            <div className="form-group">
                                <label className="label">Profile Image*</label>

                                {!showImage && (
                                    <div
                                        className="file-upload"
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                    >
                                        <input
                                            type="file"
                                            id="file-input"
                                            style={{ display: "none" }}
                                            onChange={handleFileChange}

                                        />

                                        <div
                                            className="upload-icon"
                                            onClick={() => {
                                                const fileInput =
                                                    document.getElementById("file-input");
                                                if (fileInput) {
                                                    fileInput.click();
                                                } else {
                                                    console.error("File input not found");
                                                }
                                            }}
                                        >
                                            <img src={upload} alt="Upload Icon" />
                                        </div>

                                        <div className="drag-drop-area">
                                            <p>
                                                Drag and Drop file here or{" "}
                                                <label
                                                    htmlFor="file-input"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    Choose file
                                                </label>
                                            </p>
                                            <p className="file-info">
                                                Supported formats: JPEG, PNG, SVG
                                            </p>
                      <p style={{color:"red"}}>Minimum upload size (115px X 120px)</p>

                                            {errorMessage && (
                                                <div className="error-message">{errorMessage}</div>
                                            )}
                                            {successMessage && (
                                                <div className="success-message">
                                                    {successMessage}
                                                </div>
                                            )}
                                            {imageError && (
                                                <div className="error-message" style={{color:"red"}}>
                                                    {imageError}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {state.image &&
                                    showImage && ( // Show the image if available and visible
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "inline-block",
                                            }}
                                        >
                                            <img
                                                src={state.image}
                                                alt="Uploaded Icon"
                                                style={{ width: "100px" }}
                                            />
                                            <span
                                                className='removeimg'
                                                onClick={handleImageClose}
                                            >
                                                &times;
                                            </span>
                                        </div>
                                    )}
                            </div>
                            <div className="savenew">

                                {state.id ? (
                                    <>
                                        <button
                                            className="btn btn-primary modalsubbutton mt-3 mb-3"
                                            type="button"
                                            onClick={handleUpdate}
                                        >
                                            Update
                                        </button>
                                    </>
                                ) : (
                                    <button
                                        className="btn btn-primary modalsubbutton mt-3 mb-3"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        Save
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal></>
    )
}

export default Testimonials